import { useCallback } from "react";
import { KanjiListenCounts } from "../utils/kanjiListenCountsStorage";
import { useDeviceProgress } from "./useDeviceProgress";

export function useKanjiListenCounts() {
    const { data: counts, update, syncStatus, cloudLoadFailed } = useDeviceProgress<KanjiListenCounts>("kanjiListenCounts", true);
    const increment = useCallback((key: string) => { void update({ kind: "increment", key }); }, [update]);
    return { counts, increment, syncStatus, cloudLoadFailed };
}
